import PropTypes from "prop-types";
import React from "react";
import CommonDialog from "@/Components/Common/CommonDialog";

const DeleteModal = ({ show, onDeleteClick, onCloseClick, modalTitle = "항목 삭제", message = "해당 항목을 삭제하시겠습니까?", btnText = "삭제 확인", btnColor = "danger" }) => {
  return (
    <CommonDialog
      isOpen={show}
      onClose={onCloseClick}
      title={modalTitle}
      description={message}
      tone={btnColor === "danger" ? "destructive" : "warning"}
      actions={[
        {
          label: "닫기",
          color: "light",
          closeOnClick: false,
          onClick: onCloseClick,
        },
        {
          label: btnText,
          color: btnColor,
          closeOnClick: false,
          onClick: onDeleteClick,
        },
      ]}
    />
  );
};

DeleteModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any,
};

export default DeleteModal;
